// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import _ from 'lodash'
import React, { Component } from 'react'
import { Query } from 'react-apollo'
import type { User } from '../../admin/users/userTypes'
import Container from '../../common/container/Container'
import Loader from '../../common/loader/Loader'
import { alphaSort } from '../../common/utils'
import withUser from '../auth/withUser'
import Header from '../header/Header'
import { i18n } from '../index'
import withActiveStation from '../station/withActiveStation'
import IntroductionLink from './components/introductionLink/IntroductionLink'
import css from './IntroductionLinks.css'
import { fetchAokIntroductionLinks, fetchIntroductionLinks } from './queries'
type Props = {
  user: User
}

@withUser
@withActiveStation
class IntroductionLinks extends Component<Props> {
  constructor() {
    super()
    this.state = {
      selected: '',
    }
  }

  groupAndSortLinks = (links) => {
    if (!links) {
      return []
    }
    const uniqueTags = _.uniqBy(
      links.flatMap((link) => link.linkTags ?? []),
      'id',
    )

    const groupedLinks = uniqueTags.map((tag) => ({
      tag: tag.name,
      tagId: tag.id,
      links: links.filter((link) => link.linkTags?.some((linkTag) => linkTag.id === tag.id)),
    }))
    groupedLinks.push({
      tag: i18n.t('linkTags.other'),
      tagId: 'other',
      links: links.filter((link) => !link.linkTags || link.linkTags.length === 0),
    })
    return groupedLinks
      .filter((group) => group.links.length > 0)
      .map((group) => ({
        tag: group.tag,
        links: alphaSort('fileName', group.links),
      }))
  }

  render() {
    const stationId = this.props.activeStation && this.props.activeStation.id
    const { user } = this.props
    return (
      <div className={css.component}>
        <Header title={i18n.t('introduction.header')} />
        <Container>
          <Query
            query={fetchIntroductionLinks}
            skip={!stationId}
            variables={{
              stationId,
            }}
          >
            {({ loading, error, data }) => {
              return (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  {data.introductionLinks && (
                    <React.Fragment>
                      {!!data.favoriteIntroductionLinks.length && <h3>{i18n.t('introduction.favoritesHeading')}</h3>}
                      <div>
                        {this.groupAndSortLinks(data.favoriteIntroductionLinks).map((group) => (
                          <LinkGroup
                            key={`${group.tagId}-fav`}
                            group={group}
                            stationId={stationId}
                            showFavBlock={false}
                            favoriteIntroductionLinks={data.favoriteIntroductionLinks}
                          />
                        ))}
                      </div>
                      <h3>{i18n.t('introduction.generalTitle')}</h3>
                      <div>
                        {this.groupAndSortLinks(data.introductionLinks).map((group) => (
                          <LinkGroup
                            key={group.tagId}
                            group={group}
                            stationId={stationId}
                            showFavBlock={true}
                            favoriteIntroductionLinks={data.favoriteIntroductionLinks}
                          />
                        ))}
                      </div>
                    </React.Fragment>
                  )}
                </Loader>
              )
            }}
          </Query>
          <Query
            query={fetchAokIntroductionLinks}
            variables={{
              companyId: user.company.id,
              stationId,
            }}
          >
            {({ loading, error, data }) => {
              return (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  {data.aokIntroductionLinks && (
                    <React.Fragment>
                      <h3>{i18n.t('introduction.aokTitle')}</h3>
                      <div>
                        {this.groupAndSortLinks(data.aokIntroductionLinks).map((group) => (
                          <LinkGroup
                            key={group.tagId}
                            group={group}
                            stationId={stationId}
                            showFavBlock={true}
                            favoriteIntroductionLinks={data.favoriteIntroductionLinks}
                          />
                        ))}
                      </div>
                    </React.Fragment>
                  )}
                </Loader>
              )
            }}
          </Query>
        </Container>
      </div>
    )
  }
}

interface LinkGroupProps {
  group: { tag: string; links: Link[] }
  stationId: string
  showFavBlock?: boolean
  favoriteIntroductionLinks?: Link[]
}

function LinkGroup({ group, stationId, showFavBlock, favoriteIntroductionLinks }: LinkGroupProps) {
  return (
    <>
      <h4>{group.tag}</h4>
      <div className={css.linksContainer}>
        {group.links.map((link) => (
          <IntroductionLink
            stationId={stationId}
            key={link.id}
            id={link.id}
            fileName={link.fileName}
            href={link.href}
            showFavBlock={showFavBlock}
            isFavorited={showFavBlock && favoriteIntroductionLinks?.find(({ id }) => id === link.id)}
          />
        ))}
      </div>
    </>
  )
}

export default IntroductionLinks
